import React, { Component } from 'react'
import { toast } from 'react-toastify'

import { Get } from 'utils/axios'

const HOC = ( WrappedComponent ) => {
  class WithHOC extends Component {
    state = {
      loading: false,
      medicines: []
    }

    load = param => this.setState({ loading: param })
    requestError = error => toast.error( error )
    requestSuccess = success => toast.success( success )

    getMedicines = () => Get(
      `/medicines`,
      this.getMedicinesSuccess,
      this.getMedicinesError,
      this.load
    )
    getMedicinesSuccess = payload => this.setState({ medicines: payload })
    getMedicinesError = error => this.requestError( error )

    render = () => {
      return (
        <WrappedComponent 
          { ...this.props }
          getMedicines={ this.getMedicines }
          onLoadMedicines={ this.state.loading }
          medicines={ this.state.medicines } />
      )
    }
  }
  return WithHOC
}

export default HOC